module.exports = __webpack_public_path__ + "img/f.01b01f17.svg";